<template>
    <div>
        <v-text-field
            v-model="dateFormatted"
            :label="attributes.label"
            :disabled="!attributes.editable"
            append-icon="event"
            :append-outer-icon="attributes.appendOuterIcon"
            :ref="attributes.mezo"
            :id="attributes.mezo"
            :error="this.error"
            :error-messages="this.errorMessages"
            @blur="blurFn()"
            @click:append-outer="outerIconClick()"
            attach
            :outlined="cfg.props.outlined"
            color="secondaryButtonColor"
            :placeholder="placeholder"
            :persistent-placeholder="true"
        ></v-text-field>
        <v-menu
            v-model="datepick"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :disabled="!attributes.editable"
        >
            <template v-slot:activator="{on}">
                <span v-on="on"></span>
            </template>
            <v-date-picker
                color="secondaryButtonColor"
                :value="defaultDate ? defaultDate : date"
                @input="date = $event; datepick = false"
                no-title
                class="mt-3"
                locale="hu"
                :min="min ? min : minDate"
                :max="max"
                :disabled="!attributes.editable"
                @change="changeFn($event)"
                :first-day-of-week="1"
            ></v-date-picker>
        </v-menu>
    </div>
</template>

<script>

import storeValueByPath from '../../mixins/StoreValueByPath';
import DateFormat from '../../utils/DateFormat';
import notify from '../../mixins/Notify';

export default {

    name: 'BnDate',

    mixins: [storeValueByPath],

    watch: {
        value(val) {
            if (this.standalone) {
                this.date = val;
                if (this.parseDateForServer) {
                    this.dateFormatted = this.formatDate(DateFormat.plainToDashed(val));
                } else {
                    this.dateFormatted = this.formatDate(val);
                }
            }
        },
        inputVal() {
            if (!this.standalone) {
                this.date = DateFormat.plainToDashed(this.inputVal);
                this.dateFormatted = this.formatDate(this.date);
            }
        },
    },

    data() {
        return {
            datepick: false,
            date: null,
            dateFormatted: null,
            path: this.attributes.path,
            copiedField: this.attributes.copiedField,
        };
    },

    computed: {
        placeholder() {
            if (this.dateHint) {
                return this.dateHint;
            }
            return this.cfg.props.outlined ? ' ' : '';
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        minDate() {
            return new Date('1900/01/01').toISOString()
                .substr(0, 10);
        },
    },

    methods: {
        dateChanged(val) {
            function formatDateToUser(date) {
                const d = date;
                let month = `${d.getMonth() + 1}`;
                let day = `${d.getDate()}`;
                const year = d.getFullYear();

                if (month.length < 2) month = `0${month}`;
                if (day.length < 2) day = `0${day}`;

                return [year, month, day].join('-');
            }
            if (!!val && !Number.isNaN(new Date(val).getTime())) {
                let min; let
                    max;
                if (this.min) {
                    min = new Date(this.min);
                }
                if (this.max) {
                    max = new Date(this.max);
                }
                const minMaxCheck = () => {
                    if ((
                        !min
                        || (min <= new Date(val))
                    ) && (
                        !max
                        || (max >= new Date(val))
                    )) {
                        return true;
                    }
                    if (min && !max) {
                        notify.failureNotify(
                            `Min: ${formatDateToUser(min)}`,
                            'Hibás dátum!',
                        );
                    }
                    if (max && !min) {
                        notify.failureNotify(
                            `Max: ${formatDateToUser(max)}`,
                            'Hibás dátum!',
                        );
                    }
                    if (max && min) {
                        notify.failureNotify(
                            `Min: ${formatDateToUser(min)} Max: ${formatDateToUser(max)}`,
                            'Hibás dátum!',
                        );
                    }
                    return false;
                };
                if (this.parseDateForServer) {
                    if (minMaxCheck()) {
                        this.$emit('input', DateFormat.dashedToPlain(this.date));
                    } else {
                        this.resetDates();
                    }
                } else if (minMaxCheck()) {
                    this.$emit('input', this.date);
                } else {
                    this.resetDates();
                }
            } else {
                this.resetDates();
            }
        },
        resetDates() {
            this.date = null;
            this.dateFormatted = null;
            this.$emit('input', null);
        },
        tryToFixDate(date) {
            let clonedDate = date;
            if (/^[1-9][0-9]{3}[0-1][0-9][0-3][0-9]$/.test(clonedDate)) {
                const dateStr = clonedDate.toString();
                clonedDate = `${dateStr.slice(0, 4)}.${dateStr.slice(4, 6)}.${dateStr.slice(6, 8)}.`;
            }
            return clonedDate;
        },
        parseDate(date) {
            let clonedDate = date;
            clonedDate = this.tryToFixDate(clonedDate);
            if (
                /^[1-9][0-9]{3}\.[0-1][0-9]\.[0-3][0-9]$/.test(clonedDate)
                || /^[1-9][0-9]{3}\.[0-1][0-9]\.[0-3][0-9]\.$/.test(clonedDate)
            ) {
                const [year, month, day] = clonedDate.split('.');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            }
            this.resetDates();
            return null;
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split('-');
            return `${year}.${month}.${day}.`;
        },
        setErrorBucket(error) {
            this.$refs[this.attributes.mezo].errorBucket = error;
        },

        outerIconClick() {
            if (Object.prototype.hasOwnProperty.call(this.attributes, 'outerIconClick')) {
                this.attributes.outerIconClick();
            }
        },

        blurFn() {
            this.date = this.parseDate(this.dateFormatted);
            this.dateFormatted = this.formatDate(this.date);
            this.dateChanged(this.date);
            if (Object.prototype.hasOwnProperty.call(this.attributes, 'blur')) {
                this.attributes.blur();
            }
        },

        changeFn(event) {
            // this.inputVal = this.normailzeDate(this.inputVal)
            if (this.attributes.change) {
                this.attributes.change(this.inputVal);
            }
            this.dateFormatted = this.formatDate(event);
            this.dateChanged(event);
        },

        validate() {
            this.$refs[this.attributes.mezo].validate(true);
        },
    },

    mounted() {
        const naptarIcon = this.$el.firstChild.firstChild.firstChild.children[this.cfg.props.outlined ? 2 : 1];
        naptarIcon.style = 'cursor: pointer;';
        naptarIcon.onclick = () => {
            this.datepick = !this.datepick;
        };
        if (this.standalone) {
            this.date = this.value;
            this.dateFormatted = this.formatDate(DateFormat.plainToDashed(this.date));
        } else {
            this.date = DateFormat.plainToDashed(this.inputVal);
            this.dateFormatted = this.formatDate(this.date);
        }
    },

    props: {
        value: {},
        standalone: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
        },

        error: {
            type: Boolean,
            default: false,
        },
        min: {
            type: String,
            default: undefined,
        },
        max: {
            type: String,
            default: undefined,
        },
        defaultDate: {
            type: String,
            default: undefined,
        },
        dateHint: {
            type: String,
            default: undefined,
        },
        errorMessages: {
            default: null,
        },

        afterDatePath: {
            type: String,
            default: undefined,
        },

        beforeDatePath: {
            type: String,
            default: undefined,
        },
        parseDateForServer: {
            type: Boolean,
            default: true,
        },
        attributes: {},
    },
};
</script>

<style>

</style>
